import { Field } from "formik";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import { TableNumbers } from "../../layouts/TableNumbers";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";
import { isArray } from "lodash";
import CurrencyField from "../../form/CurrencyField";
import TableHeaderCell from "../../tables/TableHeaderCell";

export default function RevisorsHandling12(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_12 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling12">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_12_question}
        sectionComplete={isCompleteHelpers.revisors_handling_12_complete}
        ref={refs.handling_12_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_11_ref);
        }}
      >
        {revisors_handling_12.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <div className="h5 fw-normal mb-3 lh-base">
            {revisors_handling_12.description}
          </div>
          <div className="h5 fw-normal mb-3 lh-base">
            {revisors_handling_12.answer_description}
          </div>
          <table className="table table-borderless table-sm table--fixed mb-5">
            <thead>
              <tr>
                <th scope="col" style={{ width: 35 }}></th>
                <TableHeaderCell>
                  {
                    revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_dato.label
                  }
                </TableHeaderCell>
                <th scope="col">
                  {
                    revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_samlet_tilsvar_input
                      .label
                  }
                </th>
                <TableHeaderCell>
                  {
                    revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_reguleringsbeloeb_input
                      .label
                  }
                </TableHeaderCell>
                <TableHeaderCell>
                  {
                    revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_reguleringsdato.label
                  }
                </TableHeaderCell>
                <TableHeaderCell className="lh-sm">
                  {
                    revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_mellemvaerende_input
                      .label
                  }
                </TableHeaderCell>
              </tr>
            </thead>
            <tbody>
              {values.revisors_handling_12_table.map((_row, index) => {
                return (
                  <tr key={index}>
                    <th scope="row" className="px-0">
                      <TableNumbers>{(index + 1).toString()}</TableNumbers>
                    </th>
                    <td className="position-relative">
                      <ValidatedField
                        touched={
                          touched.revisors_handling_12_table &&
                          isArray(touched.revisors_handling_12_table) &&
                          touched.revisors_handling_12_table[index] &&
                          (touched.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_columns_dato
                        }
                        error={
                          errors.revisors_handling_12_table &&
                          isArray(errors.revisors_handling_12_table) &&
                          errors.revisors_handling_12_table[index] &&
                          (errors.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_columns_dato
                        }
                        type="date"
                        name={`revisors_handling_12_table[${index}].revisors_handling_12_table_columns_dato`}
                      />
                    </td>
                    <td className="position-relative">
                      <CurrencyField
                        amountName={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_samlet_tilsvar_beloeb`}
                        // placeholder="0"
                        name={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_samlet_tilsvar_input`}
                        error={
                          errors.revisors_handling_12_table &&
                          isArray(errors.revisors_handling_12_table) &&
                          errors.revisors_handling_12_table[index] &&
                          (errors.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_column_samlet_tilsvar_input
                        }
                        touched={
                          touched.revisors_handling_12_table &&
                          isArray(touched.revisors_handling_12_table) &&
                          touched.revisors_handling_12_table[index] &&
                          (touched.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_column_samlet_tilsvar_input
                        }
                      />
                    </td>
                    <td className="position-relative col-4">
                      <CurrencyField
                        placeholder="0"
                        style={{ paddingLeft: "0px" }}
                        amountName={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_reguleringsbeloeb_beloeb`}
                        name={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_reguleringsbeloeb_input`}
                        toggleMinus={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_reguleringsbeloeb_plus_minus`}
                        error={
                          errors.revisors_handling_12_table &&
                          isArray(errors.revisors_handling_12_table) &&
                          errors.revisors_handling_12_table[index] &&
                          (errors.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_column_reguleringsbeloeb_input
                        }
                        touched={
                          touched.revisors_handling_12_table &&
                          isArray(touched.revisors_handling_12_table) &&
                          touched.revisors_handling_12_table[index] &&
                          (touched.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_column_reguleringsbeloeb_input
                        }
                      />
                    </td>
                    <td>
                      <Field
                        autoComplete="off"
                        className="form-control"
                        type="date"
                        name={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_reguleringsdato`}
                      />
                    </td>
                    <td>
                      <CurrencyField
                        amountName={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_mellemvaerende_beloeb`}
                        autoComplete="off"
                        placeholder="0"
                        name={`revisors_handling_12_table[${index}].revisors_handling_12_table_column_mellemvaerende_input`}
                        error={
                          errors.revisors_handling_12_table &&
                          isArray(errors.revisors_handling_12_table) &&
                          errors.revisors_handling_12_table[index] &&
                          (errors.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_column_mellemvaerende_input
                        }
                        touched={
                          touched.revisors_handling_12_table &&
                          isArray(touched.revisors_handling_12_table) &&
                          touched.revisors_handling_12_table[index] &&
                          (touched.revisors_handling_12_table[index] as any)
                            .revisors_handling_12_table_column_mellemvaerende_input
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_12.revisors_handling_12_question.id}
              id={
                revisors_handling_12.revisors_handling_12_question
                  .revisors_handling_12_question_alt_1.value
              }
              value={
                revisors_handling_12.revisors_handling_12_question
                  .revisors_handling_12_question_alt_1.value
              }
              text={
                revisors_handling_12.revisors_handling_12_question
                  .revisors_handling_12_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_12.revisors_handling_12_question.id}
              id={
                revisors_handling_12.revisors_handling_12_question
                  .revisors_handling_12_question_alt_2.value
              }
              value={
                revisors_handling_12.revisors_handling_12_question
                  .revisors_handling_12_question_alt_2.value
              }
              text={
                revisors_handling_12.revisors_handling_12_question
                  .revisors_handling_12_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_12.revisors_handling_12_alt_2_uddybning.id
                }
                className="mb-2"
              >
                {
                  revisors_handling_12.revisors_handling_12_alt_2_uddybning
                    .label
                }{" "}
                <span className="text-muted">
                  {
                    revisors_handling_12.revisors_handling_12_alt_2_uddybning
                      .sublabel
                  }
                </span>
              </label>
              <ValidatedField
                touched={touched.revisors_handling_12_alt_2_uddybning}
                error={errors.revisors_handling_12_alt_2_uddybning}
                autoComplete="off"
                as="textarea"
                id={
                  revisors_handling_12.revisors_handling_12_alt_2_uddybning.id
                }
                name={
                  revisors_handling_12.revisors_handling_12_alt_2_uddybning.id
                }
                placeholder="Beskrivelse"
                rows={2}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
